<template>
  <div class="processPage">
    <div class="leftContent">
      <p class="title">
        <span>生产线</span>
        <!-- <i class="el-icon-circle-plus-outline"></i> -->
      </p>
      <el-tree
        ref="tree"
        :data="productionLineData"
        :props="defaultProps"
        @node-click="handleNodeClick"
        highlight-current
        node-key="id"
        :expand-on-click-node="true"
      >
      </el-tree>
    </div>
    <div class="rightContent">
      <el-table
        stripe
        :data="productSopData"
        border
        style="width: 100%"
        height="100%"
        size="mini"
      >
        <el-table-column type="index" align="center"></el-table-column>
        <el-table-column
          prop="workStation"
          label="工序"
          align="center"
          min-width="110"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.workStation">{{
              scope.row.workStation.name
            }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="生产线"
          align="center"
          min-width="110"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type">{{ scope.row.type.name }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="workStation"
          label="重复执行"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.sameRedo">允许</span>
            <span class="textWarning" v-else>不允许</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="alwaysRedo"
          label="跳回执行"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.alwaysRedo">允许</span>
            <span class="textWarning" v-else>不允许</span>
          </template>
        </el-table-column>
        <el-table-column
          class-name="operation"
          label="操作"
          align="center"
          width="150px"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
              :open-delay="300"
            >
              <i @click="editSop($event, scope.row)" class="el-icon-edit"></i>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.enable"
              class="item"
              effect="dark"
              content="禁用"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="disableSop($event, scope.row)"
                class="iconfont icon-qiyong"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              content="启用"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="enableSop($event, scope.row)"
                class="iconfont icon-jinyong"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="deleteSop($event, scope.row)"
                class="el-icon-delete"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="!currentProcessKey"
              class="item"
              effect="dark"
              content="上移"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="moveUpSop($event, scope.row)"
                class="el-icon-arrow-up"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="!currentProcessKey"
              class="item"
              effect="dark"
              content="下移"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="moveDownSop($event, scope.row)"
                class="el-icon-arrow-down"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <myDialog
      ref="sopDialog"
      :title="sopDialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="sopDialogForm"
          :model="sopDialogForm"
          :rules="sopDialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="上一工序：" size="small" prop="previousId" v-if="sopDialogTitle == '添加工序'">
            <el-select
              v-model="sopDialogForm.previousId"
              placeholder="选择产品类别"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productSopList"
                :key="index"
                :label="item.workStation.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工序：" size="small" prop="workStationId">
            <el-cascader
              :options="$parent.pullDownData.workStationList"
              :props="cascaderOption"
              :show-all-levels="false"
              v-model="sopDialogForm.workStationId"
              ref="workStationCascader"
              @change="cascaderChange($event, 'workStationCascader')"
              placeholder="选择工序"
              popper-class="workStationCascader"
              :disabled="sopDialogTitle == '修改工序'"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="重复执行：" size="small" prop="sameRedo">
            <el-radio v-model="sopDialogForm.sameRedo" :label="true"
              >允许</el-radio
            >
            <el-radio v-model="sopDialogForm.sameRedo" :label="false"
              >不允许</el-radio
            >
          </el-form-item>
          <el-form-item label="跳回执行：" size="small" prop="alwaysRedo">
            <el-radio v-model="sopDialogForm.alwaysRedo" :label="true"
              >允许</el-radio
            >
            <el-radio v-model="sopDialogForm.alwaysRedo" :label="false"
              >不允许</el-radio
            >
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import {
  apiProductionLine,
  apiProductSopSearch,
  apiProductSopAdd,
  apiProductSopUpdate,
  apiProductSopDisable,
  apiProductSopEnable,
  apiProductSopDelete,
  apiProductSopMoveDown,
  apiProductSopMoveUp,
  apiProductSopList,
} from "@/api/productModel.js";
import myDialog from "@/components/myDialog.vue";
export default {
  components: {
    myDialog,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  data() {
    return {
      // tree配置
      defaultProps: {
        children: "children",
        label: "name",
      },
      // 联级配置
      cascaderOption: {
        checkStrictly: true,
        emitPath: false,
        label: "name",
        value: "id",
      },
      pullDownData: {
        productSopList: [],
      },
      currentProcessKey: undefined,
      productionLineData: [],
      productSopData: [],
      sopDialogTitle: "",
      sopDialogForm: {
        sameRedo: false,
        alwaysRedo: false,
      },
      sopDialogRules: {
        workStationId: [
          { required: true, message: "工序不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {},
  methods: {
    // 生产线
    async getProductionLineData() {
      const res = await apiProductionLine();
      if (res.code == 0) {
        this.productionLineData = JSON.parse(JSON.stringify(res.data));
        this.productionLineData.unshift({
          id: "",
          name: "全部",
        });
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentProcessKey);
        });
        this.getProductSopList();
      }
    },
    // tree点击
    handleNodeClick(data) {
      if (this.currentProcessKey == data.id) return;
      this.currentProcessKey = data.id;
      this.$parent.currentProcessKey = data.id;
      this.getProductSopSearch();
    },
    // 表格数据
    async getProductSopSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.productSopData = [];
      }
      const res = await apiProductSopSearch({
        productId: this.tabPaneValue,
        typeId: this.currentProcessKey,
      });
      // console.log(res)
      if (res.code == 0) {
        this.productSopData = res.data;
        if (callback) callback();
      }
    },
    // 新增
    addNewBtn() {
      this.sopDialogTitle = "添加工序";
      this.$refs.sopDialog.dialogVisible = true;
      this.$set(this.sopDialogForm, "workStationId", "");  
    },
    // 编辑
    editSop(e, row) {
      this.sopDialogTitle = "修改工序";
      this.$refs.sopDialog.dialogVisible = true;
      this.sopDialogForm = {
        id: row.id,
        workStationId: row.workStation.id,
        alwaysRedo: row.alwaysRedo,
        sameRedo: row.sameRedo,
      };
    },
    // 对话框提交
    submitData(title) {
      this.$refs.sopDialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "添加工序") {
            res = await apiProductSopAdd({
              ...this.sopDialogForm,
              productId: this.tabPaneValue,
            });
            if (res.code == 0) {
              this.$refs.sopDialog.dialogVisible = false;
              this.getProductSopSearch("", this.getProductSopList);
              this.$message({
                message: "添加成功",
                type: "success",
              });
            }
          } else if (title == "修改工序") {
            res = await apiProductSopUpdate({
              ...this.sopDialogForm,
              productId: this.tabPaneValue,
            });
            if (res.code == 0) {
              this.$refs.sopDialog.dialogVisible = false;
              this.getProductSopSearch("noRemove", this.getProductSopList);
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.sopDialogForm.resetFields();
      this.sopDialogForm = {
        sameRedo: false,
        alwaysRedo: false,
      };
      this.$refs.workStationCascader.$refs.panel.activePath = [];
    },
    // 禁用
    disableSop(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.workStation.name }, "禁用", "工序").then(
        async () => {
          const res = await apiProductSopDisable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductSopSearch("noRemove", this.getProductSopList);
            this.$message({
              message: "禁用成功",
              type: "success",
            });
          }
        }
      );
    },
    // 启用
    enableSop(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.workStation.name }, "启用", "工序").then(
        async () => {
          const res = await apiProductSopEnable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductSopSearch("noRemove", this.getProductSopList);
            this.$message({
              message: "启用成功",
              type: "success",
            });
          }
        }
      );
    },
    // 删除
    deleteSop(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.workStation.name }, "删除", "工序").then(
        async () => {
          const res = await apiProductSopDelete({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductSopSearch("noRemove", this.getProductSopList);
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    // 上移
    moveUpSop(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.workStation.name}】？`, "上移工序", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductSopMoveUp({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductSopSearch("noRemove", this.getProductSopList);
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移
    moveDownSop(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.workStation.name}】？`, "下移工序", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductSopMoveDown({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductSopSearch("noRemove", this.getProductSopList);
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    // 生产工序-上一工序下拉
    async getProductSopList() {
      const res = await apiProductSopList({
        productId: this.tabPaneValue,
        // typeId: this.currentProcessKey,
      });
      if (res.code == 0) {
        this.pullDownData.productSopList = res.data;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.processPage {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
<style lang="less">
.workStationCascader {
  .el-scrollbar:nth-child(1) {
    .el-radio {
      visibility: hidden;
    }
  }
}
</style>